import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        id: null,
        role: null,
        csrf: null,
        customer: {
            firstName: null,
            lastName: null,
            email: null,
        },
    }),
    actions: {
        update(params: any) {
            if (params) {
                this.id = params?.login?.id;
                this.role = params?.login?.role;
                this.csrf = params?.csrf;
                this.customer = {
                    firstName: params?.customer?.firstname,
                    lastName: params?.customer?.lastname,
                    email: params?.customer?.email,
                };
            } else {
                console.error('Unable to get "auth" store params');
            }
        },
    },
});
